import { useCallback } from "react"
import { useMutation } from "react-relay"
import { graphql } from "relay-runtime"
import {
  useStartOutboundCallMutation$data,
  useStartOutboundCallMutation as useStartOutboundCallMutationType,
} from "@/modules/telephony/services/__generated__/useStartOutboundCallMutation.graphql"

const startOutboundCallMutation = graphql`
  mutation useStartOutboundCallMutation($input: StartOutboundCallInput!) {
    startOutboundCall(input: $input) {
      startOutboundCallOutput {
        result
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

const useStartOutboundCallMutation = () => {
  const [commit, isFlight] = useMutation<useStartOutboundCallMutationType>(startOutboundCallMutation)

  const commitHandler = useCallback(
    (appointmentId: string, isRecorded: boolean, phoneNumber: string) =>
      new Promise<NonNullable<useStartOutboundCallMutation$data["startOutboundCall"]["startOutboundCallOutput"]>>(
        (resolve, reject) => {
          commit({
            variables: { input: { appointmentId, isRecorded, phoneNumber } },
            onCompleted(response) {
              if (response.startOutboundCall.startOutboundCallOutput) {
                resolve(response.startOutboundCall.startOutboundCallOutput)
              } else {
                reject(response.startOutboundCall.errors)
              }
            },
          })
        },
      ),
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useStartOutboundCallMutation }
